(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3666],{

/***/ 4153:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/authentication/login",
      function () {
        return __webpack_require__(10717);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var components_authentication_AuthFormWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6195);
/* harmony import */ var components_authentication_login__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37195);
/* harmony import */ var components_authentication_login_LoginHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91252);
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78470);
/* harmony import */ var hooks_useSlugRouter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14794);








var Login = function() {
    var client = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .a)().client;
    var router = (0,hooks_useSlugRouter__WEBPACK_IMPORTED_MODULE_7__/* .useSlugRouter */ .r)();
    var cSlug = js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("slug");
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        if (client) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            router.push("/");
        }
    }, [
        client,
        router,
        cSlug
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_authentication_AuthFormWrapper__WEBPACK_IMPORTED_MODULE_3__/* .AuthFormWrapper */ .f, {
        title: "Login",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_authentication_login_LoginHeader__WEBPACK_IMPORTED_MODULE_5__/* .LoginHeader */ .D, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_authentication_login__WEBPACK_IMPORTED_MODULE_4__/* .LoginForm */ .U, {
                isGeneral: false
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Login);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5390,7904,3368,5680,7711,4231,2595,4108,9774,2888,179], function() { return __webpack_exec__(4153); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);